/* Saint Véra · descrição detalhada (sections/sv-pdp-descricao.liquid): pontos da lupa, troca de cor, troca de idade,
   linha da tabela e botão que leva ao bloco de compra. No carregamento só observa os blocos de cor/idade para
   pré-carregar as fotos escondidas quando eles chegam perto da tela (troca sem piscar branco). */
(function () {
  var root = document.querySelector('.sv-pd');
  if (!root) return;

  root.querySelectorAll('[data-sv-pd-lupa]').forEach(function (l) {
    var pins = l.querySelectorAll('.sv-pd-pin'), list = l.querySelector('.sv-pd-pts'), items = list.querySelectorAll('li');
    function sel(i) {
      var off = pins[i].getAttribute('aria-pressed') === 'true';
      pins.forEach(function (p, j) { p.setAttribute('aria-pressed', String(!off && j === i)); });
      items.forEach(function (li, j) { li.classList.toggle('on', !off && j === i); });
      list.classList.toggle('has-sel', !off);
    }
    pins.forEach(function (p, i) { p.addEventListener('click', function () { sel(i); }); });
    items.forEach(function (li, i) { li.addEventListener('click', function () { sel(i); }); });
  });

  // Fotos escondidas (lazy + hidden) só baixariam no clique e piscariam branco: baixa ao chegar perto do bloco.
  function preload(stage) {
    var go = function () { stage.querySelectorAll('[data-i][hidden] img').forEach(function (im) { im.loading = 'eager'; }); };
    if (!('IntersectionObserver' in window)) return go();
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
    }, { rootMargin: '800px 0px' });
    io.observe(stage);
  }
  // Troca a foto só depois que a nova estiver pronta (clique rápido antes do download não deixa a área vazia).
  function show(imgs, i) {
    var next = Array.prototype.find.call(imgs, function (d) { return d.dataset.i === i; });
    var im = next && next.querySelector('img');
    var swap = function () { imgs.forEach(function (d) { d.hidden = d.dataset.i !== i; }); };
    if (!im || im.complete) return swap();
    im.loading = 'eager';
    var t = setTimeout(swap, 1500);
    im.addEventListener('load', function () { clearTimeout(t); swap(); }, { once: true });
    im.addEventListener('error', function () { clearTimeout(t); swap(); }, { once: true });
  }

  root.querySelectorAll('[data-sv-pd-cores]').forEach(function (c) {
    var imgs = c.querySelectorAll('.sv-pd-cores__img [data-i]'), nota = c.querySelector('.sv-pd-cores__nota');
    preload(c);
    c.querySelectorAll('.sv-pd-sw button').forEach(function (b, _, all) {
      b.addEventListener('click', function () {
        all.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        show(imgs, b.dataset.i);
        nota.textContent = b.dataset.nota;
      });
    });
  });

  root.querySelectorAll('[data-sv-pd-idades]').forEach(function (c) {
    var imgs = c.querySelectorAll('.sv-pd-idades__img [data-i]'), nota = c.querySelector('.sv-pd-idades__nota');
    preload(c);
    c.querySelectorAll('.sv-pd-av button').forEach(function (b, _, all) {
      b.addEventListener('click', function () {
        all.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        show(imgs, b.dataset.i);
        nota.querySelector('b').textContent = b.dataset.nome;
        nota.querySelector('span').textContent = b.dataset.nota;
      });
    });
  });

  root.querySelectorAll('.sv-pd-med tbody tr').forEach(function (tr, _, all) {
    tr.addEventListener('click', function () {
      var on = !tr.classList.contains('on');
      all.forEach(function (x) { x.classList.toggle('on', on && x === tr); });
    });
  });

  // Toque na foto editorial amplia em tela cheia (cliques mortos nessas fotos no Clarity, 20/10/2026). A lupa tem pontos próprios.
  var lb = null;
  root.addEventListener('click', function (e) {
    var im = e.target.closest('figure img');
    if (!im || im.closest('a,button,[data-sv-pd-lupa]')) return;
    if (!lb) {
      lb = document.createElement('dialog');
      lb.setAttribute('aria-label', 'Foto ampliada');
      lb.style.cssText = 'position:fixed;inset:0;padding:0;margin:0;border:0;width:100%;height:100%;max-width:none;max-height:none;background:#14100e';
      lb.innerHTML = '<img alt="" style="width:100%;height:100%;object-fit:contain;display:block">' +
        '<button type="button" aria-label="Fechar" style="position:absolute;top:14px;right:14px;width:44px;height:44px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#2a2320;font-size:28px;line-height:1;cursor:pointer">×</button>';
      lb.addEventListener('click', function () { lb.close(); });
      document.body.appendChild(lb);
    }
    var set = (im.getAttribute('srcset') || '').split(',').pop().trim().split(' ')[0];
    var big = lb.querySelector('img');
    big.src = set || im.currentSrc || im.src;
    big.alt = im.alt;
    lb.showModal();
  });
  root.querySelectorAll('figure img').forEach(function (im) { if (!im.closest('a,button,[data-sv-pd-lupa]')) im.style.cursor = 'zoom-in'; });

  // O Horizon rola .page-wrapper no desktop: usa SV.scroller() quando existir.
  var btn = root.querySelector('[data-sv-pd-buy]');
  if (btn) btn.addEventListener('click', function () {
    var buy = document.querySelector('[data-sv-buy]');
    if (!buy) return;
    var sc = (window.SV && SV.scroller) ? SV.scroller() : (document.scrollingElement || document.documentElement);
    var isDoc = sc === document.scrollingElement || sc === document.documentElement;
    var top = buy.getBoundingClientRect().top + (isDoc ? window.scrollY : sc.scrollTop) - 72;
    sc.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });
})();
